import React from 'react';
import { PokemonDetails } from '../components/PokemonDetails/PokemonDetails';


export const PokemonView = () => {
    return (
        <>
            <PokemonDetails />
        </>
    )
}
